import { makeStyles } from '@material-ui/styles';

export default makeStyles({
  titleIcon: {
    color: '#000000',
  },
});
